export const selectStep = (state) => state.quoteCreate.stepQuote;
